const validateNoCallOptions = (
  requestSponsoredProducts,
  requestDisplayAdverts
) => {
  if (requestSponsoredProducts === false && requestDisplayAdverts === false) {
    throw Error(
      `Both requestSponsoredProducts and requestDisplayAdverts are set to false. One, or both must be true before a call to the api is made`
    );
  }
};

export default validateNoCallOptions;
